ACC.product = {

    _autoload: [
        "bindToAddToCartForm",
        "enableStorePickupButton",
        "enableVariantSelectors",
        "bindFacets",
        "calculateProductPrice",
        "bindAddCart",
        ["prepareProductDescription", $(".page-homepage").length > 0],
        "selectFacet",
        "allAction",
        "showMoreOption",
        "displaySelectedFacets",
        "displayFacetsNotDisabled",
        "defaultOpenFacets",
        "bindFacetValuePopin",
        "setCertificateChoice",
        "setMkpCertificateChoice",
        "selectConfigurableFacet",
        "selectInputFacet",
        "setConfigurableFacetStatus",
        "bindCustomLengthText",
        "bindAddToCartForm",
        "encodeURL",
        "binMsgConfigurablePro",
        "viewPromoBanner"
    ],

    timer: null,
    prevQty: 0,
    productPrice: 0.0,
    transferTime: 0,
    showCart: false,

    bindFacets: function () {

        $('.js-facet-list').find('li').each(function () {
            var current = $(this).find('input');
            if (current.is(':checked')) {
                $(this).closest('div.js-facet-values').addClass("active");
                $(this).closest('div.js-facet').find('button.js-facet-name').addClass("active");
                $(this).closest('div.js-facet').find('button.js-facet-name').find('span.glyphicon').addClass("glyphicon-menu-up");
                $(this).closest('div.js-facet').find('button.js-facet-name').find('span.glyphicon').removeClass("glyphicon-menu-down");
                $(this).closest('div.js-facet-values').slideDown();
            }
        });

        $('.btn-show .show-more').on('click', function () {
            $('.show-more').addClass('hidden');
            $('.show-less').removeClass('hidden');
        });
        $('.btn-show .show-less').on('click', function () {
            $('.show-less').addClass('hidden');
            $('.show-more').removeClass('hidden');
        });

        $('#addToCartForm .addToCartButton').on('click', function () {
            var qtyInput = $('.js-qty-selector-input:visible'),
                qty = qtyInput.val();
            $('#addToCartForm .qty.js-qty-selector-input').val(qty);
            ACC.track.contentsquareAPVTracking('add-to-cart-mini-basket');
        })

        $(document).on("keyup", ".input__facet__list", function () {

            var searchText = $(this).val().toLowerCase();
            $(this).closest('div.js-facet-values').find('ul.js-facet-list').find('li').each(function () {

                var currentLiText = $(this).text();
                var pos = currentLiText.lastIndexOf('(');
                currentLiText = currentLiText.substring(0, pos).toLowerCase();
                showCurrentLi = currentLiText.indexOf(searchText) !== -1;

                $(this).toggle(showCurrentLi);

            });
        });

        bindFacetClick = function (e) {
            e.preventDefault();
            $(this).css("text-decoration", "none");
            var active = $(this).hasClass("active");
            if (active) {
                $(this).removeClass("glyphicon-menu-up");
                $(this).addClass("glyphicon-menu-down");
                $(this).removeClass("active");
            } else {
                $(this).addClass("glyphicon-menu-up");
                $(this).removeClass("glyphicon-menu-down");
                $(this).addClass("active");
            }
            $(this).closest('div.js-facet').find('div.js-facet-values').slideToggle();
        }


        $(document).on("click", ".js-facet-name", bindFacetClick);

        $(document).on("click", ".js-info-customlength", function (e) {
            $('html, body').animate({
                scrollTop: $(".configurationCheckbox").offset().top - 200
            }, 'slow');
            e.preventDefault();
            var configureProduct = $('input[name=configureProduct]');
            if (!configureProduct.is(':checked')) {
                configureProduct.click();
            }
            $(".jsConfigurableInput").focus();
        });

        $(document).on("click", ".js-show-facets", function (e) {

            $(document).on("resize", ".plp-sort", function () {
                var productsHeight = $(".plp-sort #product-facet").outerHeight();
                var newHeight = 0;
                var windowHeight = $(window).height();
                var expectedHeight = $(window).width() > 700 ? 0.6 : 0.8;
                if (productsHeight > windowHeight * expectedHeight) {
                    newHeight = parseInt(windowHeight * expectedHeight);
                } else {
                    newHeight = productsHeight + 80;
                }
                $("#colorbox.plp-sort #cboxWrapper").css("height", newHeight + "px");
                $("#colorbox.plp-sort #cboxContent").css("max-height", newHeight + "px");
            });

            e.preventDefault();
            var selectRefinementsTitle = $(this).data("selectRefinementsTitle");
            ACC.colorbox.open(selectRefinementsTitle, {
                href: ".js-product-facet",
                inline: true,
                width: "100%",
                maxHeight: "100%",
                top: 0,
                right: 0,
                fixed: true,
                className: "plp-sort",
                onComplete: function () {
                    $(document).on("click", ".js-product-facet .js-facet-name", function (e) {
                        e.preventDefault();

                        var active = $(this).parents(".js-facet").hasClass("active");
                        $(".js-product-facet  .js-facet").removeClass("active");

                        if (!active) {
                            $(this).parents(".js-facet").addClass("active");
                        }

                        $(".plp-sort").trigger($.Event('resize'));
                    });
                    $("body,#cboxOverlay").addClass("overflowHidden");
                },
                onClosed: function () {
                    $(document).off("click", ".js-product-facet .js-facet-name");
                    $("body,#cboxOverlay").removeClass("overflowHidden");
                }
            });

            $(".plp-sort").trigger($.Event('resize'));
        });
        enquire.register("screen and (min-width:" + screenSmMax + ")", function () {
            $("#cboxClose").click();
        });
    },
    enableVariantSelectors: function () {
        $('.variant-select').removeAttr("disabled");
    },

    showRequest: function (arr, $form, options) {
        var qtyInput = $('.js-qty-selector-input:visible'),
            qty = qtyInput.val();

        if ($ajaxCallEvent && qty !== "" && qty !== "0") {
            ACC.product._showQtyError(false);
            $ajaxCallEvent = false;

            /* Google Tag Manager */
            if (productData && ACC.product.productPrice !== 0) {
                var cat1 = $("#productCat1").val();
                var cat2 = $("#productCat2").val();
                var affiliation = $('.sold-by').find('span').text();
                ACC.track.add_cart(productData, ACC.product.productPrice, ACC.product.transferTime, cat1, cat2, affiliation, qty);
            }
            /* Google Tag Manager */
            return true;
        }

        return false;
    },

    bindToAddToCartForm: function () {
        const addToCartForm = $('.add_to_cart_form');
        const addToCartButton = $('#addToCartButton');
        const subMiniCart = $('.sub-mini-cart');
        const globalAlerts = $('.global-alerts');
        const notificationErr = $('.notification-err');
        const notifMkp = $('.notif-mkp');
        const cartPageContent = $('.CartPage-content');

        // Handle Add to Cart Form Submission
        handleAddToCartForm(addToCartForm);

        // Enable Add to Cart Buttons if Not Out of Stock
        enableAddToCartButtons(addToCartButton);

        // Set Ajax Call Event Flag
        setAjaxCallEventFlag();

        // Handle Sub-Mini Cart Hover and Close
        handleSubMiniCart(subMiniCart);

        // Handle Global Alerts and Notifications
        handleGlobalAlerts(notificationErr, notifMkp, globalAlerts, cartPageContent);

        function handleAddToCartForm($form) {
            $form.ajaxForm({
                beforeSubmit: ACC.product.showRequest,
                success: ACC.product.displayAddToCartPopup,
            });
        }

        function enableAddToCartButtons($buttons) {
            $buttons.each(function () {
                const $button = $(this);
                if (!$button.hasClass('outOfStock') && !$button.hasClass('out-of-stock')) {
                    $button.removeClass('disabled');
                }
            });
        }

        function setAjaxCallEventFlag() {
            setTimeout(() => {
                $ajaxCallEvent = true;
            }, 2000);
        }

        function handleSubMiniCart($cart) {
            $cart
                .mouseenter(() => {
                    ACC.product.showCart = true;
                })
                .find('.close')
                .on('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    $cart.slideUp();
                });

            $(document).on('click', (e) => {
                if (!$(e.target).closest($cart).length) {
                    $cart.slideUp();
                }
            });
        }

        function handleGlobalAlerts($notificationErr, $notifMkp, $globalAlerts, $cartPageContent) {
            // Hide global alerts if specific conditions are met
            if (
                $notificationErr.length &&
                !$notificationErr.hasClass('mkpMessage') &&
                !$notifMkp.hasClass('mkpMessage')
            ) {
                hideGlobalAlerts($globalAlerts, $notificationErr);
            }

            // Show global alerts based on cart page content conditions
            if (
                $cartPageContent.find('.notification-err.amdsMessage').length === 0 ||
                $cartPageContent.find('.notif-mkp.mkpMessage').length > 0
            ) {
                showGlobalAlerts($globalAlerts);
            }

            // Additional checks for marketplace notifications
            if ($notifMkp.hasClass('mkpMessage')) {
                manageMarketplaceNotifications($notifMkp, $globalAlerts);
            }
        }

        function hideGlobalAlerts($globalAlerts, $notificationErr) {
            if ($notificationErr.find('.alert-dismissable').length) {
                const $partnersProduct = $('.partners__product');
                if ($partnersProduct.length) {
                    $notificationErr.find('.alert-dismissable').appendTo($notificationErr);
                }

                $notificationErr
                    .find('.alert-dismissable')
                    .removeClass('alert-info alert-dismissable')
                    .addClass('alert-quantity_updated_info message');
            }
        }

        function showGlobalAlerts($globalAlerts) {
            $globalAlerts.removeClass('hidden');
        }

        function manageMarketplaceNotifications($notifMkp, $globalAlerts) {
            if ($notifMkp.find('.alert-dismissable').length) {
                $notifMkp.find('.alert-dismissable').appendTo($notifMkp);
                $notifMkp
                    .find('.alert-dismissable')
                    .removeClass('alert-info alert-dismissable')
                    .addClass('alert-quantity_updated_info message');
            }
        }
    },


    calculateConfigurations: function (itemCharacteristics) {

        var facetValue, facetType;
        $('.configurableSelect.active:not(.disabled) input[type=checkbox]:checked').each(function (index) {

            if ($(this).attr('name').indexOf('_') !== -1) {
                facetValue = $(this).attr('name').split('_')[1];
                facetType = $(this).attr('name').split('_')[0];
                itemCharacteristics[facetType] = facetValue;
            }

        });

        if ($('.jsConfigurableInput.active').length != 0) {
            $('.jsConfigurableInput.active').each(function (index) {
                var confInputId = $(this).attr('id');
                var stdFacet = $('#' + confInputId + ' div.value.checked');
                if ($(this).val().length > 0) {
                    itemCharacteristics[confInputId] = $(this).val();
//                  Add manuel :The shape treatment type corresponding to the value “Right saw cut” todo : if confInputId == SE01
                    itemCharacteristics['OO22'] = 'VI00001';
                } else if (!jQuery.isEmptyObject(itemCharacteristics) && stdFacet.length > 0) {
                    itemCharacteristics[confInputId] = $('#' + confInputId + ' input[type=checkbox]:checked').val();
                }
            });
        } else if (!jQuery.isEmptyObject(itemCharacteristics)) {
            var se01Facet = $('#SE01 div.value.checked');
            if (se01Facet.length > 0) {
                //              Add manuel :The (length) For config product:
                itemCharacteristics['SE01'] = $('#SE01 input[type=checkbox]:checked').val();
            }
        }


        if (!jQuery.isEmptyObject(itemCharacteristics)) {
            var sf27Facet = $('#SF27 div.value.checked');
            if (sf27Facet.length > 0) {
                //              Add manuel :The (Width) For Flat product:
                itemCharacteristics['SF27'] = $('#SF27 input[type=checkbox]:checked').val();
            }
        }


    },
    calculateProductPrice: function () {
        let requestCounter = 0,
            isCertificateCheckedByUser = false;

        $(".js-qty-selector-input").on('input', function () {
            $('.postPriceHT-loader, .productWeightValue-loader, .certificatePrice-loader').hide().fadeOut(200);

            if ($('.related-offers').length > 0) {
                $('.sold-by').addClass('hidden').find('.vendor').html();
            }

            // Increment the counter for each new request
            requestCounter++;
            let currentRequest = requestCounter;

            ACC.productDetail.checkConfigurableInput();
            let qtyInput = $(this),
                selectPdp = $('.price-table .select-options li[rel="bundle"]'),
                selectpieces = $('.price-table .select-options li[rel="pieces"]'),
                isbundle,
                qty = parseInt(qtyInput.val()),
                productCode = $('#productCodePost').val(),
                maxQty = qtyInput.data('max-normal'),
                maxbundle = $(".js-qty-selector-input").data('max-bundle'),
                minweight = parseFloat(qtyInput.data('minweight')),
                maxBundle = $(".js-qty-selector-input").attr('data-max-bundle'),
                maxPiece = $(".js-qty-selector-input").attr('data-max-normal');

            if (!qty) {
                $('.vendor-info-msg').addClass('hidden');
                qtyInput.removeClass('min-order');
                $('.js-amds-checkCertif_product').addClass('hidden');
                isCertificateCheckedByUser = false;
            }

            let MAX_LIMIT = 9999;

            function setQtyAttributes(maxValue, isBundle) {
                qtyInput.attr({"data-max": maxValue, "data-maxor": maxValue});
                isbundle = isBundle;
            }

            if (selectPdp.hasClass('selected')) {
                setQtyAttributes(maxBundle, true);
            } else if (selectpieces.hasClass('selected')) {
                let hasConfigurableInput = $(".jsConfigurableInput").val() !== "";
                setQtyAttributes(hasConfigurableInput ? MAX_LIMIT : maxPiece, false);
            } else {
                let isNoLimit = $(".price-table").hasClass("no-limit");
                setQtyAttributes(isNoLimit ? MAX_LIMIT : maxPiece, false);
            }


            if (!isNaN(qty) && qty !== "" && qty !== 0 && qty > 0) {
                // Contrôler la quantité pour qu'elle ne dépasse pas le maximum
                qty = Math.min(qty, MAX_LIMIT);
                qtyInput.val(qty);

                // reset UI
                ACC.product._renderExtraPack(false, false);
            }
            $('.availability-message-block:not(.visible)').addClass('invisible');

            //if (qty != ACC.product.prevQty) {
            ACC.product.prevQty = qty;

            if (qty !== "" && qty !== 0 && qty > 0) {
                $('.productPrices, .productEuroT, .productEuroKg, .productEuroM, .productEuroM2, .productWeight, .productLength, .add-cmp-block, .certificatePriceValue').addClass('hidden');
                $('.productPrices-loader, .productEuroT-loader, .productEuroKg-loader, .productEuroM-loader, .productEuroM2-loader, .productWeight-loader, .productLength-loader, .postPriceHT-loader, .productWeightValue-loader, .certificatePrice-loader').fadeIn(200);
                $('.postPriceHT, .productWeightValue').text('');

                isCertificateCheckedByUser = $('#checkCertif_product').is(':checked');
                ACC.product._showQtyError(false);

                let configureProduct = $('input[name=configureProduct]').is(':checked'),
                    itemCharacteristics = {};

                if (configureProduct) {
                    ACC.product.calculateConfigurations(itemCharacteristics);

                    if (!$.isEmptyObject(itemCharacteristics) && itemCharacteristics["SE01"] !== undefined) {
                        productCode = $('#configurableProduct').val() || $('#configurableProductPdp').val();
                    } else {
                        // Réinitialisation des caractéristiques si condition non remplie
                        itemCharacteristics = {};
                    }
                } else {
                    // Si le produit n'est pas configurable, assigner le produit configuré par défaut
                    productCode = $('#configuredProduct').val();
                }

                let qtyMax = isbundle ? maxbundle : maxQty;

                if (productCode && qty) {
                    window._uxa = window._uxa || [];
                    window._uxa.push(['setCustomVariable', 20, "product_quantity", qty]);

                    // Créer une nouvelle requête AJAX
                    $.ajax({

                        url: 'p/productPrice',
                        method: 'GET',
                        data: {
                            productCode: productCode,
                            requestedQuantity: qty,
                            maxQuantity: qtyMax,
                            isBundle: isbundle,
                            itemCharacteristics: JSON.stringify(itemCharacteristics)
                        },
                        beforeSend: function () {
                            console.log('Requête en cours d\'envoi...');
                        },
                        success: function (response) {
                            if(response ===''){
                                location.reload()
                            }
                            // Only process the response if it's from the most recent request
                            if (response !=="" && currentRequest === requestCounter) {
                                let prixHT = response.priceHT,
                                    postPriceHT = response.postPriceHT,
                                    postPriceIncCertificate = response.postPriceIncCertificateHT,
                                    prixTTC = response.priceTTC,
                                    weightValue = response.weightValue,
                                    weightUnit = response.weightUnit,
                                    productWeightValue = response.weightValue,
                                    cartWeightUnit = response.cartWeightUnit,
                                    lengthValue = response.lengthValue,
                                    loyaltyPoints = response.loyaltyPoints,
                                    isMarketplace = response.marketplace,
                                    isBundle = response.bundle,
                                    isExtraPack = response.extraPack,
                                    deliveryDate = response.deliveryDate,
                                    lengthUnit = response.lengthUnit,
                                    formattedCertificatePrice = response.formattedCertificatePrice,
                                    mkpFormattedCertificatePrice = response.mkpFormattedCertificatePrice,
                                    certificateType = response.certificateType,
                                    certificatedAgency = requestCounter == 2 ? response.certificatedAgency : 0,
                                    itemsConditions = response.itemsConditions,
                                    uomPrice = response.uomPrice,
                                    uomUnit = response.uomUnit,
                                    itemsConditionJson = response.itemsConditionJson,
                                    amdsCertificateType = response.wsCertificateType;


                                const isPriceZero = (postPriceHT == 0 || postPriceHT == null);


                                if (!response.displayQuoteButton && deliveryDate) {
                                    $('.add-cmp-block')
                                        .removeClass('hidden')
                                        .find('.text-date').html(deliveryDate);
                                }

                                ACC.product.productPrice = prixHT || 0;

                                if (qty > qtyMax && configureProduct == false) {
                                    $(".js-qty-req").text(qty);
                                    $(".js-qty-dispo").text(qtyMax);
                                    $(".addToCartButton").removeAttr('disabled');
                                    $('.productPrices-loader').hide();
                                    $('.productEuroT-loader').hide();
                                    $('.productEuroKg-loader').hide();
                                    $('.productEuroM-loader').hide();
                                    $('.productEuroM2-loader').hide();
                                    $('.productWeight-loader').hide();
                                    $('.productLength-loader').hide();
                                    $('.productPrices').addClass('hidden');
                                    $('.postPriceHT').addClass('hidden');
                                    $('.select-arrow').addClass('hidden');
                                    $('.price-details').addClass('hidden');

                                    if (isMarketplace) {
                                        ACC.product._renderPrice(prixHT, prixTTC, uomPrice, uomUnit, isMarketplace);
                                        ACC.product._renderMkpCertificate(mkpFormattedCertificatePrice, response.mkpCertificateName, certificatedAgency);
                                    } else {
                                        $('.productEuroM, .productEuroT, .productPrices').addClass('invisible');
                                        ACC.product._renderCertificate(formattedCertificatePrice, certificateType, certificatedAgency, amdsCertificateType, isCertificateCheckedByUser);
                                    }

                                    ACC.product._renderWeight(weightValue, weightUnit);
                                    ACC.product._renderLength(lengthValue, lengthUnit);
                                    ACC.product._renderPriceUomVisibility(minweight, productWeightValue, cartWeightUnit, isMarketplace);
                                    ACC.product._renderProductConfigQuery(JSON.stringify(itemCharacteristics), productCode);
                                    ACC.product._renderConfigProductPrice(itemsConditions);
                                    ACC.product._renderLoyaltyPoints(loyaltyPoints);
                                    ACC.product._renderExtraPack(isExtraPack, true, isPriceZero);
                                    const $addToCartComponent = $(".addtocart-component");
                                    $addToCartComponent.find(".dispo-stock__enstock").addClass("invisible").parent('div').addClass('hidden');
                                    $addToCartComponent.find(".under-stock").removeClass("invisible");

                                    $("button.normal-add").addClass("hidden");
                                    $("button.quotation-add").removeClass("hidden disabled tooltip");


                                    ACC.productDetail.checkConfigurableInput();
                                    $('.js-delivery-date-available').addClass('hidden');
                                    $('.js-delivery-date-unavailable').removeClass('hidden');

                                    if (isBundle) {
                                        $(".dispo-stock__enstock.dispo-stock-bundle").addClass("hidden");
                                        $(".dispo-stock-bundle.under-stock").removeClass("invisible");
                                    }
                                    // Récupération de l'état de certification
                                    const isCertified = $('.checkCertif_product').is(':checked');
                                    // Mise à jour du prix HT et des attributs en fonction de la certification
                                    const priceToDisplay = isCertified ? postPriceIncCertificate : postPriceHT;
                                    $('.postPriceHT')
                                        .text(priceToDisplay)
                                        .attr({
                                            'data-price': postPriceHT,
                                            'data-price-inc-certificate': postPriceIncCertificate
                                        });

                                    $('.productWeightValue').text(productWeightValue);
                                    $('.postPriceHT-loader, .productWeightValue-loader, .certificatePrice-loader').hide();
                                    $(".availability-message-block").removeClass('invisible');
                                    $('.default-extra-pack-fees').addClass('hidden');
                                    $(".availability-message-block .qty-key").removeClass('invisible hidden');
                                    if (isBundle && maxbundle == 0) {
                                        $(".availability-message-block .qty-key").addClass('invisible hidden');
                                    }
                                } else {
                                    const $addToCartComponent = $(".addtocart-component");
                                    const $productLoaders = $('.productPrices-loader, .productEuroT-loader, .productEuroKg-loader, .productEuroM-loader, .productEuroM2-loader, .productWeight-loader, .productLength-loader');
                                    const $productElements = $('.productPrices, .productEuroM, .productEuroT');
                                    const $postPriceHT = $('.postPriceHT');
                                    const $productWeightValue = $('.productWeightValue');
                                    const isCertified = $('.checkCertif_product').is(':checked');
                                    const isPriceZero = postPriceHT == null || postPriceHT === "null" || postPriceHT === "" || parseFloat(postPriceHT.replace(',','.')) == 0 ;

                                    // Mise à jour des composants de stock
                                    $addToCartComponent.find(".under-stock").addClass("invisible");
                                    $addToCartComponent.find(".dispo-stock__enstock").removeClass("invisible").parent('div').removeClass('hidden');

                                    // Masquer les loaders et afficher les éléments de prix et unités
                                    $productLoaders.hide();
                                    $productElements.removeClass('invisible');

                                    // Rendu des informations produit
                                    ACC.product._renderPrice(prixHT, prixTTC, uomPrice, uomUnit, isMarketplace);
                                    ACC.product._renderWeight(weightValue, weightUnit);
                                    ACC.product._renderLength(lengthValue, lengthUnit);

                                    // Appels aux fonctions de rendu des caractéristiques produit
                                    ACC.product._renderPriceUomVisibility(minweight, productWeightValue, cartWeightUnit);
                                    ACC.product._renderProductConfigQuery(JSON.stringify(itemCharacteristics), productCode);
                                    ACC.product._renderConfigProductPrice(itemsConditions);
                                    ACC.product._renderExtraPack(isExtraPack, false, isPriceZero);
                                    ACC.product._renderLoyaltyPoints(loyaltyPoints, !isPriceZero);

                                    // Affichage des boutons
                                    $("button.normal-add").removeClass("hidden");
                                    $("button.quotation-add").addClass("hidden disabled tooltip");

                                    ACC.productDetail.checkConfigurableInput();

                                    $('.js-delivery-date-unavailable').addClass('hidden');
                                    $('.js-delivery-date-available').removeClass('hidden');

                                    // Mise à jour du prix HT et des attributs en fonction de la certification
                                    $postPriceHT.text(isCertified ? postPriceIncCertificate : postPriceHT).attr({
                                        'data-price': postPriceHT,
                                        'data-price-inc-certificate': postPriceIncCertificate
                                    }).removeClass('hidden');

                                    $productWeightValue.text(productWeightValue);
                                    $('.select-arrow, .price-details, .default-extra-pack-fees').removeClass('hidden');
                                    $('.postPriceHT-loader, .productWeightValue-loader, .certificatePrice-loader').hide();

                                    // Cacher les éléments si le prix est zéro
                                    $postPriceHT.toggleClass('hidden', isPriceZero);
                                    $productWeightValue.toggleClass('hidden', isPriceZero);

                                    //No prices !
                                    if (ACC.product.productPrice === 0 || parseFloat(ACC.product.productPrice.replace(',','.')) == 0 || $('#isRFQ').val() == 'true' || (parseFloat(ACC.product.productPrice.replace(',','.')) == 0 && $('#isRFQ').val() == 'true')) {
                                        $('#isRFQ').val(true);
                                        $('#itemConditions').val(itemsConditionJson);
                                        $('#productLength').val(lengthValue);
                                        $("button.normal-add").addClass("hidden");
                                        $("button.quotation-add").removeClass("hidden disabled tooltip").removeAttrs('disabled');
                                        $(".availability-message-block , .info-block-details").removeClass('invisible hidden');
                                        if (!isBundle) {
                                            $(".availability-message-block .qty-key").addClass('invisible hidden');
                                        }
                                        $('.add-cmp-block, .extra-table-bloc, .select-arrow, .price-details, .msg-min-order, .postPriceHT').addClass('hidden');
                                        $('.dispo-stock.dispo-stock-normal').addClass("hidden-stock");
                                    }

                                    // Rendu des certificats selon le type de marché
                                    if(isMarketplace) {
                                        ACC.product._renderMkpCertificate(mkpFormattedCertificatePrice, response.mkpCertificateName, certificatedAgency);
                                    } else {
                                        ACC.product._renderCertificate(formattedCertificatePrice, certificateType, certificatedAgency, amdsCertificateType, isCertificateCheckedByUser);
                                    }
                                }
                                // Si le produit est un marketplace
                                response.marketplace && ACC.product.mp(response, qtyMax, qty);
                                ACC.product._soldBy(response.mkpOfferVendor, response.mkpCodeVendor, response.marketplace);
                                $('.postPriceHT-loader, .productWeightValue-loader, .certificatePrice-loader').hide().fadeOut(200);
                            }
                        }
                    });
                }

            } else {
                $('.productPrices-loader, .productEuroT-loader, .productEuroKg-loader, .productEuroM-loader, .productEuroM2-loader, .productWeight-loader, .productLength-loader').hide();
                $('.productPrices, .productEuroT, .productEuroKg, .productEuroM, .productEuroM2, .productWeight, .productLength').addClass('hidden');
                $('.add-cmp-block, .extra-table-bloc, .select-arrow, .price-details, .msg-min-order').addClass('hidden');
                $('.postPriceHT').text('').addClass('hidden');
                $('.productWeightValue').text('');
                $('.certificatePrice-loader').hide();
                $('.related-offers .offer').removeClass('hidden');
                $(".decreased-price").addClass("display-none");
                $('.js-amds-checkCertif_product_mkp .amds-checkbox').addClass('hidden');
                ACC.product._renderExtraPack(false, false);
                $('.addToCartButton').attr('disabled', 'disabled').addClass('disabled tooltip');
                isCertificateCheckedByUser = false;
            }
            // }
        });

    },
    mp: function (response, qtyMax, qty) {
        const {
            calculatedEuroT,
            calculatedEuroM,
            prixHT,
            lengthValue,
            vendorMinOrderMessagekey,
            vendorMinOrderMessageValue,
            offerSalesUnit,
            mkpOfferVendor,
            marketplace,
            mkpCodeVendor,
            mkpOfferCode,
            offerContainingDecreasingPrices,
            mkpFormattedCertificatePrice,
        } = response;

        const qtyInput = parseInt($('.js-qty-selector-input:visible').val(), 10);
        const overstock = qty > qtyMax;
        const addToCartButton = $('.addToCartButton');
        const mkpOfferMinOrderQuantity = parseInt(response.mkpOfferMinOrderQuantity)


        // Handle Overstock Scenario
        handleOverstock(marketplace, overstock, qtyMax, qty, addToCartButton);

        // Display Price Details
        displayPriceDetails(mkpOfferVendor, calculatedEuroM, lengthValue, calculatedEuroT, prixHT);

        // Display Vendor Message Block if Min Order Quantity is NaN
        displayVendorMessageBlock(vendorMinOrderMessagekey, mkpOfferVendor, vendorMinOrderMessageValue, offerSalesUnit);

        // Handle Minimum Order Quantity
        handleMinimumOrderQuantity(mkpOfferMinOrderQuantity, qtyInput, mkpOfferCode, qtyMax, vendorMinOrderMessagekey);

        // Reset Add to Cart Button State if No Winner Offer
        if (mkpOfferCode == null) {
            resetAddToCartButton(addToCartButton);
        }

        // Hide Winner Offer from List
        hideWinnerOfferFromList(mkpOfferCode);

        // Hide Quotation Button for Non-Operator Vendors
        hideQuotationButtonForNonOperators(mkpCodeVendor);

        // Toggle Decreasing Prices Visibility
        toggleDecreasingPricesVisibility(offerContainingDecreasingPrices);

        // Check and Display Certificate Information
        ACC.product._checkCertificat(mkpFormattedCertificatePrice);


        function handleOverstock(marketplace, overstock, qtyMax, qty, addToCartButton) {
            if (marketplace && overstock) {
                $('.vendor-info-msg').addClass('hidden');
                $('.mkp_over_stock_error_msg .qty-max').text(qtyMax);
                $('.mkp_over_stock_error_msg .qty-selected').text(qty);
                $('.mkp_over_stock_error_msg').removeClass('hidden invisible');
                addToCartButton.attr('disabled', 'disabled').toggleClass('normal-btn tooltip disabled', !mkpOfferVendor);
            } else {
                $('.mkp_over_stock_error_msg').addClass('hidden');
                addToCartButton.removeAttr('disabled').removeClass('disabled tooltip');
            }
        }

        function displayPriceDetails(mkpOfferVendor, calculatedEuroM, lengthValue, calculatedEuroT, prixHT) {
            ACC.product._mkpPriceDisplay(mkpOfferVendor, calculatedEuroM, lengthValue, calculatedEuroT, prixHT);
        }

        function handleMinimumOrderQuantity(mkpOfferMinOrderQuantity, qtyInput, mkpOfferCode, qtyMax, vendorMinOrderMessagekey) {
            ACC.product._mkpOfferMinOrderQuantity(
                parseInt(mkpOfferMinOrderQuantity, 10),
                qtyInput,
                mkpOfferCode,
                qtyMax,
                vendorMinOrderMessagekey
            );
        }

        function displayVendorMessageBlock(vendorMinOrderMessagekey, mkpOfferVendor, vendorMinOrderMessageValue, offerSalesUnit) {
            ACC.product._vendorMessageBlock(vendorMinOrderMessagekey, mkpOfferVendor, vendorMinOrderMessageValue, offerSalesUnit);
        }

        function resetAddToCartButton(addToCartButton) {
            addToCartButton.removeClass('normal-btn disabled');
        }

        function hideWinnerOfferFromList(mkpOfferCode) {
            ACC.product._hideWinnerOfferFromList(mkpOfferCode);
        }

        function hideQuotationButtonForNonOperators(mkpCodeVendor) {
            if (mkpCodeVendor !== 'operator') {
                $("button.quotation-add").addClass("hidden disabled tooltip");
            }
        }

        function toggleDecreasingPricesVisibility(offerContainingDecreasingPrices) {
            $(".decreased-price, .decreasing-asterrisk-js").toggleClass("display-none", !offerContainingDecreasingPrices);
        }
    },
    _checkCertificat: function (mkpFormattedCertificatePrice) {
        $('.js-amds-checkCertif_product_mkp .amds-checkbox').toggleClass('hidden', mkpFormattedCertificatePrice === null);
    },
    _hideWinnerOfferFromList: function (mkpOfferCode) {
        const $relatedOffers = $('.related-offers');
        const $tableList = $('.table_list');

        if (mkpOfferCode && mkpOfferCode.trim() !== '') {
            // Show the table list and hide the winner offer
            handleWinnerOffer($relatedOffers, $tableList, mkpOfferCode);

            // Check and update buttons and stock availability
            updateUIElements();
        } else {
            // Ensure the table list is visible if no winner offer code is provided
            $tableList.removeClass('hidden');
        }

        function handleWinnerOffer($relatedOffers, $tableList, mkpOfferCode) {
            $tableList.removeClass('hidden'); // Ensure the table list is visible
            $('#' + mkpOfferCode).addClass('hidden'); // Hide the winner offer

            // If there's only one offer left, hide the related offers section
            if ($relatedOffers.find('.offer').length === 1) {
                $relatedOffers.addClass('hidden');
            }
        }

        function updateUIElements() {
            // Show the "normal-add" button
            $('.normal-add').removeClass('hidden');

            // Show stock availability in the add-to-cart component
            $(".addtocart-component .dispo-stock__enstock").removeClass("hidden invisible");

            // Show all stock availability indicators within related offers
            $('.related-offers').find('.dispo-stock').removeClass('hidden');
        }

    },

    _mkpOfferMinOrderQuantity: function (mkpOfferMinOrderQuantity, qtyInput, mkpOfferCode, qtyMax, vendorMinOrderMessagekey) {
        if (!isNaN(mkpOfferMinOrderQuantity) && mkpOfferMinOrderQuantity !== 0 && qtyInput < mkpOfferMinOrderQuantity) {
            $('.addtocart-component .msg-min-order').removeClass('hidden').find('.minOrderQuantity').html(mkpOfferMinOrderQuantity);
            $('.js-qty-selector-input').addClass('min-order');
            $('.select-arrow').addClass('mt-60');
            //if ($('.related-offers').length == 0 || vendorMinOrderMessagekey) {
            $('.addToCartButton')
                .removeClass('normal-btn')
                .addClass('tooltip disabled')
                .attr('disabled', 'disabled');
            // }
        } else {
            $('.js-qty-selector-input').removeClass('min-order');
            $(".addtocart-component .msg-min-order").addClass("hidden");
            $('.select-arrow').removeClass('mt-60');
            if ($('.related-offers').length == 0 && mkpOfferCode != null) {
                $('.addToCartButton').removeAttr('disabled');
            }
        }
    },
    _mkpPriceDisplay: function (mkpOfferVendor, prixEuroM, lengthValue, prixEuroT, prixHT) {
        if (mkpOfferVendor !== null) {
            if (prixEuroM === null || lengthValue === "") {
                $('.EuroM').addClass('hidden');
            }
            $('.productEuroT')
                .removeClass('hidden')
                .find('span').text(prixEuroT);// price_euroT

            $('.productPrices')
                .removeClass('hidden')
                .find('.price_ht span').text(prixHT);//prixHT
        }
    },
    _vendorMessageBlock: function (vendorMinOrderMessagekey, mkpOfferVendor, vendorMinOrderMessageValue, offerSalesUnit) {
        $('.minOrderAmount,.minOrderQty,.minOrderkg ').addClass('hidden');
        if (vendorMinOrderMessagekey) {
            $('.msg-min-order, .colon').addClass('hidden');
            if (vendorMinOrderMessagekey == 'minOrderAmount') {
                $('.minOrderAmount').removeClass('hidden').find('span').html(vendorMinOrderMessageValue);
                $('.colon').removeClass('hidden');
            }
            if (vendorMinOrderMessagekey == 'minOrderQty') {
                $('.minOrderQty').removeClass('hidden').find('span').html(vendorMinOrderMessageValue);
                $('.offerSalesUnit').html(offerSalesUnit);
                $('.colon').removeClass('hidden');
            }
            if (vendorMinOrderMessagekey == 'minOrderkg') {
                $('.minOrderkg').removeClass('hidden').find('span').html(vendorMinOrderMessageValue);
                $('.colon').removeClass('hidden');
            }
            $('.vendor-info-msg').removeClass('hidden');
        }
    },
    _soldBy: function (mkpOfferVendor, mkpCodeVendor, marketplace) {
        $('.sold-by').addClass('hidden').find('.vendor').html();
        if (mkpOfferVendor !== null) {
            $('.sold-by')
                .removeClass('hidden')
                .find('.vendor')
                .html(mkpOfferVendor);
            if (marketplace) {
                $('.sold-by a').attr('href', ACC.config.encodedContextPath + '/vendor/' + mkpCodeVendor);
            }
        }
    },
    _renderPrice: function (prixHT, prixTTC, uomPrice, uomUnit, isMarketplace) {
        var productPrices = $('.productPrices'),
            qtyInput = $('.js-qty-selector-input'),
            qty = parseInt(qtyInput.val()),
            infoBlockDetails = $('.info-block-details');
        var cellT = $('.cellT');
        var cellM = $('.cellM');
        var cell100M = $('.cell100M');
        var cell100M2 = $('.cell100M2');
        var cellKg = $('.cellKg');
        var lenghtwrapper = $('.wlenghtcell');
        var inStock = $('.addtocart-component .dispo-stock__enstock');

        cellT.addClass('hidden');
        cellM.addClass('hidden');
        cell100M2.addClass('hidden');
        cell100M.addClass('hidden');
        cellKg.addClass('hidden');
        lenghtwrapper.addClass('hidden');


        if (uomPrice && (uomUnit == "TO" || uomUnit == "EuroT" || uomUnit == "1000KG")) {
            var cellT = $('.cellT');
            var allcell = $('.js-bundle .cell');
            var priceEuroT = $('.productEuroT');
            var lenghtcell = $('.wlenghtcell .lenghtcell');
            priceEuroT.removeClass('hidden');
            priceEuroT.find('.price_euroT span').html(uomPrice);
            allcell.not('.hidden').addClass('hidden');
            cellT.removeClass('hidden');
            lenghtwrapper.addClass('hidden');
            lenghtcell.addClass('hidden');
            if (uomPrice == 0) {
                infoBlockDetails.addClass('hidden');
                priceEuroT.addClass('hidden');
                cellT.addClass('hidden');
                $('.info-block-details').addClass('invisible');
            } else {
                infoBlockDetails.removeClass('hidden');
                priceEuroT.removeClass('hidden');
                cellT.removeClass('hidden');
            }

        }
        if (uomPrice && (uomUnit == "EuroM" || uomUnit == "M")) {
            var cellM = $('.cellM');
            var allcell = $('.js-bundle .cell');
            var lenghtwrapper = $('.wlenghtcell');
            var lenghtcell = $('.wlenghtcell .lenghtcell');
            var priceEuroM = $('.productEuroM');
            priceEuroM.removeClass('hidden');
            priceEuroM.find('.price_euroM span').html(uomPrice);
            allcell.not('.hidden').addClass('hidden');
            cellM.removeClass('hidden');
            lenghtcell.removeClass('hidden');
            lenghtwrapper.removeClass('hidden');

            if (uomPrice == 0) {
                infoBlockDetails.addClass('hidden');
                priceEuroM.addClass('hidden');
                cellM.addClass('hidden');
            } else {
                infoBlockDetails.removeClass('hidden');
                priceEuroM.removeClass('hidden');
                cellM.removeClass('hidden');
            }
        }
        if (uomPrice && uomUnit == "100M") {
            var allcell = $('.js-bundle .cell');
            var lenghtwrapper = $('.wlenghtcell');
            var lenghtcell = $('.wlenghtcell .lenghtcell');
            var priceEuroM = $('.productEuroM');
            priceEuroM.removeClass('hidden');
            priceEuroM.find('.price_euroM span').html(uomPrice);
            allcell.not('.hidden').addClass('hidden');
            cell100M.removeClass('hidden');
            lenghtcell.removeClass('hidden');
            lenghtwrapper.removeClass('hidden');
            if (uomPrice == 0) {
                infoBlockDetails.addClass('hidden');
                priceEuroM.addClass('hidden');
                $('.cell100M').addClass('hidden');
            } else {
                infoBlockDetails.removeClass('hidden');
                priceEuroM.removeClass('hidden');
                $('.cell100M').removeClass('hidden');
            }
        }
        if (uomPrice && uomUnit == "KG") {
            var cellKg = $('.cellKg');
            var allcell = $('.js-bundle .cell');
            var priceEuroKg = $('.productEuroKg');
            var lenghtwrapper = $('.wlenghtcell');
            var lenghtcell = $('.wlenghtcell .lenghtcell');
            priceEuroKg.removeClass('hidden');
            priceEuroKg.find('.price_euroKg span').html(uomPrice);
            allcell.not('.hidden').addClass('hidden');
            cellKg.removeClass('hidden');
            lenghtwrapper.addClass('hidden');
            lenghtcell.addClass('hidden');
            if (uomPrice == 0) {
                infoBlockDetails.addClass('hidden');
                priceEuroKg.addClass('hidden');
                cellKg.addClass('hidden');
            } else {
                infoBlockDetails.removeClass('hidden');
                priceEuroKg.removeClass('hidden');
                cellKg.removeClass('hidden');
            }
        }
        if (uomPrice && uomUnit == "M2") {
            var cellKg = $('.cellM2');
            var priceEuroKg = $('.productEuroM2');
            var lenghtwrapper = $('.wlenghtcell');
            var lenghtcell = $('.wlenghtcell .lenghtcell');


            priceEuroKg.removeClass('hidden');
            priceEuroKg.find('.price_euroM2 span').html(uomPrice);
            cellKg.removeClass('hidden');
            lenghtwrapper.addClass('hidden');
            lenghtcell.addClass('hidden');
            if (uomPrice == 0) {
                infoBlockDetails.addClass('hidden');
                priceEuroKg.addClass('hidden');
                cellKg.addClass('hidden');
            } else {
                infoBlockDetails.removeClass('hidden');
                priceEuroKg.removeClass('hidden');
                cellKg.removeClass('hidden');
            }
        }
        if (uomPrice && uomUnit == "100M2") {
            var priceEuroKg = $('.productEuroM2');
            var lenghtwrapper = $('.wlenghtcell');
            var lenghtcell = $('.wlenghtcell .lenghtcell');
            priceEuroKg.removeClass('hidden');
            priceEuroKg.find('.price_euroM2 span').html(uomPrice);
            cell100M2.removeClass('hidden');
            lenghtwrapper.addClass('hidden');
            lenghtcell.addClass('hidden');
            lenghtwrapper.addClass('hidden');
            if (uomPrice == 0) {
                infoBlockDetails.addClass('hidden');
                priceEuroKg.addClass('hidden');
                $('.cellM2').addClass('hidden');
            } else {
                infoBlockDetails.removeClass('hidden');
                priceEuroKg.removeClass('hidden');
                $('.cellM2').removeClass('hidden');
            }
        }
        if (prixHT !== "" && prixTTC !== "" && prixHT != null && parseFloat(prixHT.replace(',', '.')) > 0) {
            productPrices.removeClass('hidden');
            productPrices.find('.price_ht span').html(prixHT);
            productPrices.find('.price_ttc span').html(prixTTC);
            $('.addToCartButton').removeAttr("disabled");
            $('.addToCartButton').removeClass('disabled tooltip');
            if (!uomPrice == 0) {
                infoBlockDetails.removeClass('hidden');
            }
        } else {
            infoBlockDetails.addClass('hidden');
            $('.addToCartButton').attr("disabled", "disabled");
            $('.addToCartButton').addClass('disabled tooltip');
            $('.addToCartButton.06').removeClass("hidden")
        }
        if (isMarketplace && (uomPrice === null && uomUnit === null)) {
            infoBlockDetails.removeClass('hidden');
            inStock.addClass('hidden');
        }
    },
    _renderWeight: function (weightValue, weightUnit) {
        var productWeight = $('.productWeight');
        var detailsWeight = $('.detailsWeight');
        if (weightValue) {
            if (parseFloat(weightValue) >= 0 && weightValue !== "" && weightUnit !== "") {
                productWeight.removeClass('hidden');
                productWeight.find('.weightValue').html(weightValue);
                productWeight.find('.weightUnit').html(weightUnit);
            }
        }
    },
    _renderLength: function (lengthValue, lengthUnit) {
        var productLength = $('.productLength');
        if (lengthValue) {
            if (parseFloat(lengthValue.replace(/[^\d\.\-]/g, "")) > 0 && lengthValue !== "" && lengthUnit !== "") {
                productLength.removeClass('hidden');
                productLength.find('.lengthValue').html(lengthValue);
                productLength.find('.lengthUnit').html(lengthUnit);
            }
        }
    },
    _renderCertificate: function (certificatePrice, certificateType, certificatedAgency, amdsCertificateType, isCertificateCheckedByUser) {
        var certificatewrapper = $('.certificatewrapper'),
            certificatePriceValue = $('.certificatePriceValue');

        certificatewrapper.addClass('hidden');
        certificatePriceValue.addClass('hidden');

        if(!jQuery.isEmptyObject(amdsCertificateType)) {
            $("#amdsCertificateType").val(amdsCertificateType);
        }

        if (!jQuery.isEmptyObject(certificatePrice) && !jQuery.isEmptyObject(certificateType) || certificatePrice > 0) {
            $('.certificatePriceValue').find("span").html(certificatePrice);
            $('.js-amds-checkCertif_product').removeClass('hidden');
            $("#certificateEnabled").val(certificatedAgency);
            if (certificatedAgency || isCertificateCheckedByUser) {
                $('.js-amds-checkCertif_product #checkCertif_product').prop("checked", true);
                ACC.product.setCertificateChoiceLogic(true, false);
            }
        }
        $('.productCertificatePrice').text(certificatePrice);
    },
    _renderPriceUomVisibility: function (minweight, weightValue, weightUnit) {
        if (minweight != null && weightValue < minweight) {
            var visibility = document.getElementsByClassName('visibleOnLoad');
            if (visibility.length <= 0) {
                $('.price_unit').addClass('hidden');
            }
            $('.euro_T_title').hide();
            $('.productEuroT').parent('td').hide();
            $('.euro_M_title').hide();
            $('.productEuroM').parent('td').hide();
            $('.length-table').hide();
        } else {
            $('.price_unit').removeClass('hidden');

            $('.euro_T_title').show();
            $('.productEuroT').parent('td').show();
            $('.euro_M_title').show();
            $('.productEuroM').parent('td').show();
            $('.length-table').show();
        }
    },
    _renderProductConfigQuery: function (configQuery, productCode) {
        if (configQuery != null) {
            $('.js-config-selector-input').val(configQuery);
            $('.js-configProduct-selector-input').val(productCode);
        }
    },
    _renderConfigProductPrice: function (itemsConditions) {
        if (!jQuery.isEmptyObject(itemsConditions)) {
            $('.extra-table-bloc').removeClass('hidden');
            $('.extra-table tr[class^="tr_price__"]').addClass('hidden');
            $('.extra-table tr[class^="tr_price__"] div[class^="div_price__"]').addClass('hidden');
            $('.extra-table tr[class^="tr_price__"] div[class^="div_price__"] span[class^="price_"]').html("")

            $.each(itemsConditions, function (key, itemsCondition) {
                if (itemsCondition.totalPrice != '') {
                    $('.tr_price__' + itemsCondition.code).removeClass('hidden');
                    $('.tr_price__' + itemsCondition.code + ' th').html(itemsCondition.label)
                    $('.div_price__' + itemsCondition.code).removeClass('hidden');
                    $('.price_' + itemsCondition.code).html(itemsCondition.totalPrice);
                }
            });
        } else {
            $('.extra-table-bloc').addClass('hidden');
        }
    },
    _renderExtraPack: function (isExtraPack, isPartiallyAvailableProduct, isPriceUnavailable) {
        const extraPackFeesSelector = isPartiallyAvailableProduct || isPriceUnavailable ? '.under-stock .js-extraPackFees' : '.js-extraPackFees';
        $('.js-qty-selector-input').removeClass('extra-pack-fees-warning');
        if (isExtraPack) {
            $('.js-qty-selector-input').addClass('extra-pack-fees-warning')
            $(extraPackFeesSelector).removeClass("hidden");

            if ($('.js-amds-checkCertif_product:visible')) {
                let extraPackFeesHeight = $('.extraPackFees:visible').outerHeight();
                $('.select-arrow').css("margin-top", extraPackFeesHeight + 25)
            }

        } else {
            $('.js-extraPackFees').addClass("hidden");

            if ($('.js-amds-checkCertif_product:visible')) {
                $('.select-arrow').css("margin-top", 13)
            }
        }

        $('.under-stock .js-extraPackFees').not(extraPackFeesSelector).addClass("hidden");
        $('.js-extraPackFees').not(extraPackFeesSelector).addClass("hidden");
    },
    _renderLoyaltyPoints: function (loyaltyPoints, isPriceZero) {
        if (isPriceZero && loyaltyPoints && loyaltyPoints > 0) {
            $('.loyalty-pdp-msg').removeClass('hidden');
            var nbrPoint = $(".js-loyalty-pdp").find("span");
            $(".js-loyalty-pdp").find("span").text(loyaltyPoints);
        } else {
            $('.loyalty-pdp-msg').addClass('hidden');
        }
    },
    _showQtyError: function (show) {
        var qtyInput = $('.js-qty-selector-input'),
            qtyInputError = qtyInput.parent().find('.msg-error'),
            qty = parseInt(qtyInput.val());

        if (show) {
            if (!qtyInput.hasClass('qty-input-error')) {
                qtyInput.addClass('qty-input-error');
            }
            if (qty < 0) {
                qtyInput.val('');
            }
            qtyInputError.removeClass('hidden');
            /* Google Tag Manager */
            ACC.track.errorQuantityEvent();
            /* Google Tag Manager */

            $('.productPrices').addClass('hidden');
            $('.productWeight').addClass('hidden');
            $('.productLength').addClass('hidden');
            $('.productEuroT').addClass('hidden');
            $('.productEuroM').addClass('hidden');
            $('.productEuroKg').addClass('hidden');
//            $('.detailsWeight').addClass('hidden');

            $('#addToCartButton').attr("disabled", "disabled");
            $('.select-arrow').addClass('hidden');
            $('.price-details').addClass('hidden');
            $('.postPriceHT').addClass('hidden');

        } else {
            qtyInput.removeClass('qty-input-error');
            if (!qtyInputError.hasClass('hidden')) {
                qtyInputError.addClass('hidden');
            }
            /*$('#addToCartButton').removeAttr("disabled");*/
        }
    },
    bindToAddToCartStorePickUpForm: function () {
        var addToCartStorePickUpForm = $('#colorbox #add_to_cart_storepickup_form');
        addToCartStorePickUpForm.ajaxForm({success: ACC.product.displayAddToCartPopup});
    },
    enableStorePickupButton: function () {
        $('.js-pickup-in-store-button').removeAttr("disabled");
    },
    displayAddToCartPopup: function (cartResult, statusText, xhr, formElement) {
        var izbergApiErrorMessage = cartResult.izbergApiErrorMessage;
        if (izbergApiErrorMessage != '') {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow', function () {
                // Once scrolling is complete, show the message
                $('.global-alerts').html('<div class="alert alert-danger alert-dismissable"><button class="close" aria-hidden="true" data-dismiss="alert" type="button">×</button>' + izbergApiErrorMessage + '</div>');
            });
        }
        
        if(cartResult?.reloadWhenOfferStockInsufficient) {
            setTimeout(() => {
                location.reload(true);
            }, 2000)
            return;
        }

        $ajaxCallEvent = true;
        $('#addToCartLayer').remove();

        if (typeof ACC.minicart.updateMiniCartDisplay == 'function') {
            ACC.minicart.updateMiniCartDisplay();
        }

        var productCode = $('[name=productCodePost]', formElement).val();
        var quantityField = $('[name=qty]', formElement).val();
        var titleHeader = ACC.product.resolveAddToCartTitle(cartResult);
        if (izbergApiErrorMessage == '') {
            $('.content-sub-cart').html(cartResult.addToCartLayer);
            $('.sub-mini-cart').slideDown();
            setTimeout(function () {
                $('.sub-mini-cart').slideUp();
            }, 4000);
        }

        var addToCartButton = $('.addToCartButton').not(".hidden");
        var addToCartButtonTextInit = addToCartButton.html();
        if (formElement && izbergApiErrorMessage == '') {
            //addToCartButton.removeClass("waiting").addClass("validating").html(addToCartButton.data('validatedBtnText'));
            addToCartButton.html(addToCartButton.data('validatedBtnText'));
            setTimeout(function () {
                addToCartButton.removeClass("validating").html(addToCartButtonTextInit).blur();
            }, 2000);

        }
        if (izbergApiErrorMessage !== '') {
            addToCartButton.removeClass("waiting").html(addToCartButtonTextInit).blur();
        }

        /*ACC.colorbox.open(titleHeader, {
            html: cartResult.addToCartLayer,
            width: "460px"
        });*/

        var quantity = 1;
        if (quantityField != undefined) {
            quantity = quantityField;
        }

        var cartAnalyticsData = cartResult.cartAnalyticsData;

        var cartData = {
            "cartCode": cartAnalyticsData.cartCode,
            "productCode": productCode, "quantity": quantity,
            "productPrice": cartAnalyticsData.productPostPrice,
            "productName": cartAnalyticsData.productName
        };

        ACC.track.trackAddToCart(productCode, quantity, cartData);
    },
    resolveAddToCartTitle: function (cartResult) {
        var titleHeader = $('#addToCartTitle').html();
        if (cartResult.cartData.noItemAdded) {
            titleHeader = $('#noItemAddedAddToCartTitle').html();
        }
        return titleHeader;

    },
    encodeURL: function () {

        $(document).on("click", ".obflink", function (e) {
            var link = $(this).data('o');
            /*var linkDecoded = atob(link);*/
            var linkDecoded = decodeURIComponent(escape(window.atob(link)));
            var url = decodeURI(linkDecoded); ///p/P110010010?q=GE30:LAC+décapé    /p/P110010010?q=GE30:GalvanisÃ©
            window.location = ACC.config.encodedContextPath + url;
        });
    },
    prepareProductDescription: function () {
        var length = 70;
        var details = null;
        var original_html = null;
        var original_text = null;
        var truncated_text = null;
        $('.carousel__item--description').each(function () {
            details = $(this);
            original_html = details.html();
            original_text = details.text();

            if (original_text.length > length) {
                truncated_text = $.trim(original_text).substring(0, length).split(" ").slice(0, -1).join(" ") + " ...";
                details.html(truncated_text);
            } else {
                details.html(original_text);
            }
        });
    },
    bindAddCart: function () {

        $('.cartmobileactive').each(function () {
            if ($(this).css('display') === 'none') {
                $(this).remove()
            }

        });

        $('.cartdesktopactive').each(function () {
            if ($(this).css('display') === 'none') {
                $(this).remove()
            }

        });


    },
    showMoreOption: function () {
        $('.variant-element').not(".opened").each(function () {
            if ($('fieldset', this).height() > $('.variant-values', this).height()) {
                $('.options', this).show();
            } else {
                $('.options', this).hide();
            }
        })
    },
    allAction: function () {
        $(document).on('click', '.show-values', function (e) {
            $(this).closest('.options').siblings('.variant-values').css({'max-height': '100%'});
            $(this).hide();
            $(this).closest(".variant-element").addClass("opened");
            $(this).siblings('.hide-values').show();
        });
        $(document).on('click', '.hide-values', function (e) {
            $(this).closest('.options').siblings('.variant-values').removeAttr('style');
            $(this).hide();
            $(this).closest(".variant-element").removeClass("opened");
            $(this).siblings('.show-values').show();
            ACC.product.displaySelectedFacets();
            ACC.product.displayFacetsNotDisabled();
        });
        $(document).on('click', 'span.removeFiltres', function (e) {
            $('.value input[type="checkbox"]').prop('checked', false);
            $('.value').removeClass('checked');
            $('.value input').trigger("change");
            ACC.product.hoverQualityProduct();
        })
        ACC.product.hoverRAL();
        $(window).resize(function () {
            ACC.product.showMoreOption();
        })
        $(document).on('click', '.facet-event', function (e) {
            var i = 0;
            var text = $('.not-selected-text .text').data('text');
            $('.variant-element:not(.conf-js)').each(function () {
                if ($('input:checked', this).length == 0 && $('input:disabled', this).length != $('input', this).length) {
                    var facetCode = $(this).find('.variant-values fieldset').attr('id');
                    var isNotSelected = true;
                    $('.jsConfigurableInput.active').each(function (index) {
                        var confInputId = $(this).attr('id');

                        if (confInputId === facetCode && $(this).val()) {
                            isNotSelected = false;
                            return false;
                        }
                    });

                    if (isNotSelected) {
                        i != 0 ? text += ', ' : '';
                        $('.not-selected-icon', this).show();
                        text += ' [' + $('.not-selected-icon', this).data('title') + ']';
                        i++;
                    }
                }
            })
            if (i != 0) {
                $('.not-selected-text .text').text(text + '.');
                $('.not-selected-text').show()
            }
        });
    },
    selectFacet: function () {
        $(document).on('change', '.value input', ACC.product.handleSelectFacet);
        $(document).on('change', '.value input', ACC.product.hoverQualityProduct);
    },
    binMsgConfigurablePro: function () {
        $(".disabled #configureProductLabel").mouseenter(function () {
            $(this).find('.configureProductMsg').show();
        }).mouseleave(function () {
            $(this).find('.configureProductMsg').hide();
        })
    },
    selectInputFacet: function () {
        $(document).on('focusout', '.jsConfigurableInput', function () {

            $('.js-amds-checkCertif_product').addClass('hidden');
            $('.postPriceHT, .right-col .select-arrow, .right-col .price-details ').addClass('hidden');
            $('.productWeightValue').text('');

            ACC.productDetail.checkConfigurableInput();
            var max = $(this).data('max');
            var min = $(this).data('min');
            if (max < min) {
                var midle = min;
                min = max;
                max = midle;
            }
            var length = $(this).val();
            if (isNaN(length) && length != "") {
                length = length.replace(/\D/g, '');
                $(this).val(length);
            }
            if (!isNaN(length) && length != "" && max != '' && length > max) {
                $(this).val(max);
            } else if (!isNaN(length) && length != "" && min != '' && length < min) {
                $(this).val(min);
            }
            if ($(this).val().length != 0) {
                ACC.productDetail.enableAddToCart();
            } else {
                $('#SE50 div.configurableSelect').addClass("disabled");
                var disableAddToCart = true;
                $('.configurableSelect.active:not(.disabled) input').each(function (index) {
                    if ($(this).is(':checked')) {
                        disableAddToCart = false;
                    }
                });
                if (disableAddToCart) {
                    ACC.productDetail.disableAddToCart();
                }
            }
            ACC.product.showLoader();
            ACC.productDetail.cleanCartInfos();
            var variantBloc = $(this).closest('.variant-values');
            var inputElement = $(this).closest('.value');
            var facetteNames = $(this).closest('.variant-element').find('.not-selected-icon').data('title');
            var facetteCodes = $(this).attr("name");
            var facetteValues = $(this).val();
            $(this).closest('.variant-values').find('.value').removeClass('checked');
            var query = $(this).data('query');
            var baseProductCode = $(this).data('product');
            var isVariant = $(this).data('isvariant');
            ACC.product.hoverQualityProduct();
            if ($(this).is(':checked')) {
                $(this).closest('.value').addClass('checked');
                ACC.product.hoverQualityProduct();
            } else {
                $(this).closest('.value').removeClass('checked');
            }
            var baseUrl = ACC.config.encodedContextPath + "/p/variants/" + baseProductCode;
            var configureProduct = $('input[name=configureProduct]').is(':checked');
            var configuredInputMap = new Object();
            var configuredSelectMap = new Object();
            var currentFacet = $(this);

            if (configureProduct) {
                $('.jsConfigurableInput.active').each(function (index) {
                    var confInputId = $(this).attr('id');

                    if (confInputId === facetteCodes) {
                        if (currentFacet.is(':checked')) {
                            $(this).val('');
                        } else {
                            configuredInputMap[facetteCodes] = "";
                        }
                    }
                    if ($(this).val()) {
                        configuredInputMap[$(this).attr('id')] = $(this).val();
                    }
                });

                $('.configurableSelect.active:not(.disabled) input[type=checkbox]:checked').each(function (index) {
                    configuredSelectMap[$(this).closest("fieldset").attr('id')] = ($(this).attr('name'));
                });
            }

            $.ajax({
                url: baseUrl,
                dataType: 'json',
                data: {
                    "q": ACC.product.calculateURL(baseUrl),
                    "var": isVariant,
                    "configureProduct": configureProduct,
                    "configuredInputMap": JSON.stringify(configuredInputMap),
                    "configuredSelectMap": JSON.stringify(configuredSelectMap)
                },
                async: false,
                success: function (data) {
                    if (data.redirecturl.length == 0) {
                        $('.ajax-product-details').html(data.productdetails);
                        $('.ajax-confProduct-details').html(data.confproductdetails);
                        ACC.product.bindCustomLengthText();
                        ACC.product.showMoreOption();
                        ACC.product.displaySelectedFacets();
                        ACC.product.displayFacetsNotDisabled();
                        ACC.product.hoverRAL();
                        ACC.product.hideLoader();
                        ACC.product.defaultOpenFacets();
                        ACC.product.setConfigurableFacetStatus();
                        ACC.product.setAddToCartForConfig();
                        ACC.product.binMsgConfigurablePro();
                    } else {
                        $(location).attr('href', data.redirecturl);
                    }
                }
            });
        });

        $(document).on('keypress', '.jsConfigurableInput', function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);

            $(this).val($(this).val().replace(/\s/g, '').replace(/[^\d].+/, ""));
            if ((keycode < 48 || keycode > 57) && keycode != 13) {
                ACC.register.showError($(this), errorsMsg['number']['notvalid']);
            } else {
                ACC.register.hideError($(this));
            }
            if (keycode == '13') {
                $(this).focusout();
            }
        });

        $(document).on("click", ".js-configurableDiv", function (e) {
            e.preventDefault();
            if ($('.jsConfigurableInput', this).prop('disabled')) {
                $('.js-customLengthTxt').removeClass('hidden');
            }
        });

    },
    handleSelectFacet: function (e) {
        ACC.product.showLoader();
        ACC.productDetail.cleanCartInfos();
        var variantBloc = $(this).closest('.variant-values');
        var inputElement = $(this).closest('.value');
        var facetteNames = $(this).closest('.variant-element').find('.not-selected-icon').data('title');
        var facetteCodes = $(this).attr("name");
        var facetteValues = $(this).val();
        $(this).closest('.variant-values').find('.value').removeClass('checked');
        var query = $(this).data('query');
        var baseProductCode = $(this).data('product');
        var isVariant = $(this).data('isvariant');
        ACC.product.hoverQualityProduct();
        if ($(this).is(':checked')) {
            $(this).closest('.value').addClass('checked');
            ACC.product.hoverQualityProduct();
        } else {
            $(this).closest('.value').removeClass('checked');
        }
        var baseUrl = ACC.config.encodedContextPath + "/p/variants/" + baseProductCode;


        var configureProduct = $('input[name=configureProduct]').is(':checked');
        var configuredInputMap = new Object();
        var configuredSelectMap = new Object();
        var currentFacet = $(this);

        if (configureProduct) {
            $('.jsConfigurableInput.active').each(function (index) {
                var confInputId = $(this).attr('id');

                if (confInputId === facetteCodes) {
                    if (currentFacet.is(':checked')) {
                        $(this).val('');
                    } else {
                        configuredInputMap[facetteCodes] = "";
                    }

                }
                if ($(this).val()) {
                    configuredInputMap[$(this).attr('id')] = $(this).val();
                }

            });

            $('.configurableSelect.active:not(.disabled) input[type=checkbox]:checked').each(function (index) {
                configuredSelectMap[$(this).closest("fieldset").attr('id')] = ($(this).attr('name'));
            });
        }


        $.ajax({
            url: baseUrl,
            dataType: 'json',
            data: {
                "q": ACC.product.calculateURL(baseUrl),
                "var": isVariant,
                "configureProduct": configureProduct,
                "configuredInputMap": JSON.stringify(configuredInputMap),
                "configuredSelectMap": JSON.stringify(configuredSelectMap)
            },
            async: false,
            success: function (data) {
                if (data.redirecturl.length == 0) {
                    $('.ajax-product-details').html(data.productdetails);
                    $('.ajax-confProduct-details').html(data.confproductdetails);
                    ACC.product.bindCustomLengthText();
                    ACC.product.showMoreOption();
                    ACC.product.displaySelectedFacets();
                    ACC.product.displayFacetsNotDisabled();
                    ACC.product.hoverRAL();
                    ACC.product.hideLoader();
                    ACC.product.defaultOpenFacets();
                    ACC.product.setConfigurableFacetStatus();
                    ACC.product.setAddToCartForConfig();
                    ACC.product.binMsgConfigurablePro();
                } else {
                    $(location).attr('href', data.redirecturl);
                }
            }
        });
    },
    selectConfigurableFacet: function () {
        $(document).on('change', '.configurableSelect.active input', function (e) {

            $('.js-amds-checkCertif_product').addClass('hidden');
            $('.postPriceHT, .right-col .select-arrow, .right-col .price-details ').addClass('hidden');
            $('.productWeightValue').text('');

            if (!$(this).closest('.configurableSelect').hasClass('disabled')) {
                ACC.productDetail.cleanCartInfos();
                ACC.product.hoverQualityProduct();
                $(this).closest('.variant-values').find('.configurableSelect').removeClass('checked');

                if ($(this).is(':checked')) {
                    $(this).closest('.configurableSelect').addClass('checked');
                    $(this).closest('.variant-values').find('.configurableSelect input').prop('checked', false);
                    $(this).prop('checked', true);
                    // ACC.productDetail.enableAddToCart();
                    var itemCharacteristics = new Object();
                    ACC.product.calculateConfigurations(itemCharacteristics);
                    ACC.product.hoverQualityProduct();

                    if (!jQuery.isEmptyObject(itemCharacteristics) && itemCharacteristics["SE01"] == undefined) {
                        $('.js-qty-selector-input').prop('disabled', true);
                    }
                } else {
                    if ($(this).attr("name").indexOf("SE50") != -1) {
                        $(this).prop('checked', true);
                        $(this).closest('.configurableSelect').addClass('checked');

                    } else {
                        $(this).closest('.configurableSelect').removeClass('checked');
                        $(this).closest('.variant-values').find('.configurableSelect input').prop('checked', false);
                        var disableAddToCart = true;
                        var configureProduct = $('input[name=configureProduct]').is(':checked');
                        $('.jsConfigurableInput.active').each(function (index) {
                            if (configureProduct && $(this).val().length != 0) {
                                disableAddToCart = false;

                            }
                        });
                        ACC.product.hoverQualityProduct();
                    }
                }
            }


        })
    },
    setAddToCartForConfig: function () {

        var configureProduct = $('input[name=configureProduct]').is(':checked');
        var itemCharacteristics = new Object();

        if (configureProduct && $('#configurableProduct').val()) {
            ACC.product.calculateConfigurations(itemCharacteristics);

            if (!jQuery.isEmptyObject(itemCharacteristics)) {
                ACC.productDetail.enableAddToCart();
                if (itemCharacteristics["SE01"] == undefined) {
                    $('.js-qty-selector-input').prop('disabled', true);
                }

            }
        } else {
            ACC.product.calculateConfigurations(itemCharacteristics);
            if (!jQuery.isEmptyObject(itemCharacteristics) && itemCharacteristics["SE01"] == undefined) {
                $('.js-qty-selector-input').prop('disabled', true);
            }
        }

    },
    bindCustomLengthText: function () {
        if ($('.jsConfigurableInput').length != 0 && $('.jsConfigurableInput').attr('id') == 'SE01' && $('#configureProductCheckbox').prop('disabled') == false) {
            $('.ajax-product-details').find('.js-info-customlength').removeClass('hidden');
        }
    },
    setConfigurableFacetStatus: function () {

        var configureProduct = $('input[name=configureProduct]').is(':checked');

        $('.jsConfigurableInput').each(function (index) {
            var confInputId = $(this).attr('id');
            var stdFacet = $('#' + confInputId + ' div.value.checked');
            if (configureProduct && $(this).val() != '') {
                $('#' + confInputId + ' div.value').addClass("forceDisabled").removeClass("checked");
                $(this).prop('disabled', false);
                $('.js-customLengthTxt').addClass('hidden');
            } else if (stdFacet.length > 0) {
                $(this).val("");
            } else {
                $('#' + confInputId + ' div.value').removeClass("forceDisabled");
                $('#' + confInputId + ' input[type=checkbox]:checked').closest('.value').addClass("checked");
                ACC.product.hoverQualityProduct();
                if (configureProduct && $(this).data("is-custom-length-excluded") !== 'DISABLED') {
                    $(this).prop('disabled', false);
                    $('.js-customLengthTxt').addClass('hidden');
                } else {
                    $(this).prop('disabled', true);
                    $(this).val("");
                }

            }
        });

        var customLength = $('#SE01.jsConfigurableInput');
        if (customLength.length) {
            if (customLength.is(':disabled') || customLength.val() === '') {
                $('#SE50 div.configurableSelect').addClass("disabled");
            } else {
                $('#SE50 div.configurableSelect.active').removeClass("disabled");
            }
        }
    },
    bindFacetValuePopin: function () {

        $(document).on('click', '.js-value-popin', function (e) {
            selector = $(this);
            var baseUrl = ACC.config.encodedContextPath + "/p/info-popin";
            var facetCode = selector.closest('.variant-element').find('.variant-values fieldset').attr('id');
            var curentFacetCode = $('.js-facet-code').html();
            var tableFacetTitle = $('.js-facet-title').html();
            var tableFacetdesc = $('.js-facet-description').html();
            $('.js-popin-headline').html(selector.data('title'));
            /* Contentsquare */
            if (facetCode == "GE30") {
                ACC.track.contentsquareAPVTracking("product-see-our-guide-process-sub-family");
            } else if (facetCode == "MS01") {
                ACC.track.contentsquareAPVTracking("product-see-our-guide-grade");
            }
            /* Contentsquare */
            var baseProduct = selector.data('baseproduct');
            var names = ACC.product.calculateFacets(selector);
            if (facetCode == curentFacetCode) {
                $('#popinFacetInfo').modal("toggle");
            } else {
                if (names !== undefined && names.length != 0) {
                    $.ajax({
                        url: baseUrl,
                        dataType: 'json',
                        data: {
                            "facetCode": facetCode,
                            "baseProduct": baseProduct,
                            "names": names
                        },
//                  async: false,
                        type: "GET",
                        traditional: true,
                        success: function (data) {
                            if (!jQuery.isEmptyObject(data)) {
                                $('.js-empty-description').hide();
                                $('.js-table-popin').show();
                                $('.js-table-popin').html('<tr><th>' + tableFacetTitle + '</th><th>' + tableFacetdesc + '</th></tr>');

                                $.each(data, function (key, value) {
                                    $('.js-table-popin').append('<tr><td class="' + (value.mostSold ? 'mostSold' : '') + '">' + value.title + '</td><td>' + value.description + '</td></tr>');
                                });
                            } else {
                                $('.js-table-popin').hide();
                                $('.js-empty-description').show();
                            }
                            $('.js-facet-code').html(facetCode);
                            $('#popinFacetInfo').modal("toggle");
                        }
                    });
                } else {
                    console.error("Couldn't send request due to names being undefined");
                }
            }
        })
    },
    calculateURL: function (baseUrl) {
//      var calculatedURL = baseUrl + "?q=";
        var calculatedURL = "";
        $('.variant-values:not(.configurations-values) fieldset').each(function (index) {
            if ($(this).find('.checked input:checked').length > 0) {
                calculatedURL += $(this)[0].id + ":" + encodeURIComponent($(this).find('.checked input:checked')[0].value)
                if (($('.variant-values fieldset').length - 1) != index) {
                    calculatedURL += ":";
                }
            }
        })
        return calculatedURL;
    },
    calculateFacets: function (selector) {
        var variantElement = selector.closest('.variant-element');
        var facets = [];
        var fid_MS01 = $(variantElement).find('.variant-values fieldset').attr('id') === 'MS01';
        $(variantElement).find('.variant-values fieldset .value input').each(function () {
            if (fid_MS01) {
                if (!$(this).is(':disabled')) {
                    facets.push($(this).val());
                }
            } else {
                facets.push($(this).val());
            }
        })
        return facets;
    },
    displaySelectedFacets: function () {
        $('.variant-values').each(function (index) {
            var inputElement = $(this).find('.checked')
            if (inputElement.length > 0 && !ACC.common.isVisable(inputElement, $(this))) {
                $(this).stop().animate({
                    scrollTop: ($(inputElement).offset().top - $(this).offset().top)
                }, 1000);
            }
        })
    },
    displayFacetsNotDisabled: function () {
        $('.variant-values').each(function (index) {
            var inputElement = $(this).find('.value:not(.disabled)')
            if (inputElement.length > 0 && !ACC.common.isVisable(inputElement[0], $(this))) {
                $(this).stop().animate({
                    scrollTop: ($(inputElement[0]).offset().top - $(this).offset().top)
                }, 1000);
            }
        })
    },
    showLoader: function () {
        $('.modal-loader').show();
    },
    hideLoader: function () {
        $('.modal-loader').hide();
    },
    hoverRAL: function () {
        $('.ral-color').hover(function () {
            var color = $("label", this).data("color");
            $("label", this).css({"background-color": color, "color": "#fff", "border-color": "#B0B1B5"})
        }, function () {
            var color = $("label", this).data("color");
            $("label", this).css({"background-color": "", "color": "", "border-color": ""})
        })
    },
    defaultOpenFacets: function () {
        $('fieldset').each(function (index) {
            if ($(this).attr('id') === "MS01" || $(this).attr('id') === "GE30") {
                $(this).closest('.variant-values').siblings('.options').find('.show-values').click();
            }
        })
    },
    setCertificateChoice: function () {
        $("#checkCertif_product").change(function () {
            ACC.product.setCertificateChoiceLogic(this.checked, false);
        });
    },
    setMkpCertificateChoice: function () {
        $("#checkMkpCertif_product").change(function () {
            ACC.product.setCertificateChoiceLogic(this.checked, true);
        });
    },
    setCertificateChoiceLogic: function (isChecked, isMKP) {
        var certificatewrapper = $('.certificatewrapper'),
            certificatePriceValue = $('.certificatePriceValue'),
            postPriceHT = $('.postPriceHT').attr('data-price'),
            postPriceIncCertificateHT = $('.postPriceHT').attr('data-price-inc-certificate');

        if (isChecked) {
            if(isMKP) {
                $("#withMkpCertificate").val("true");
            } else {
                $("#certificateEnabled").val("true");
            }
            certificatewrapper.removeClass("hidden");
            certificatePriceValue.removeClass("hidden");
            $('.postPriceHT').text(postPriceIncCertificateHT);
        } else {
            if(isMKP) {
                $("#withMkpCertificate").val("false");
            } else {
                $("#certificateEnabled").val("false");
            }
            certificatewrapper.addClass("hidden");
            certificatePriceValue.addClass("hidden");
            $('.postPriceHT').text(postPriceHT);
        }
    },
    getUrlParameter: function (sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] != undefined;
            }
        }
    },
    bindAddToCartForm: function () {
        var cq = ACC.product.getUrlParameter('cq');
        if (cq) {
            ACC.productDetail.cleanCartInfos();
            ACC.productDetail.enableAddToCart();
            var itemCharacteristics = new Object();
            ACC.product.calculateConfigurations(itemCharacteristics);

            if (!jQuery.isEmptyObject(itemCharacteristics) && itemCharacteristics["SE01"] == undefined) {
                $('.js-qty-selector-input').prop('disabled', true);
            }
        }
    },
    encodeURL: function () {
        $(document).on("click", ".obflink", function (e) {
            var link = $(this).data('o');
            /*var linkDecoded = atob(link);*/
            var linkDecoded = decodeURIComponent(escape(window.atob(link)));
            var url = decodeURI(linkDecoded); ///p/P110010010?q=GE30:LAC+décapé    /p/P110010010?q=GE30:GalvanisÃ©
            window.location = ACC.config.encodedContextPath + url;
        });
    },
    hoverQualityProduct: function () {
        $(".variant-values .qualityLabel").each(function (index) {
            var $this = $(this);
            var label = $this.parents(".variant-element").find(".qualityLabelSpan");
            $this.mouseenter(function (e) {
                var position = $(this).position();
                var positionX = $(this).outerWidth() / 2;
                var positionY = $(this).outerHeight() / 2;
                var pleft = position.left + positionX;
                var ptop = position.top + positionY;
                label.css({left: pleft + (positionX / 2), top: ptop + 8});
                label.show();
            });
            $this.mouseleave(function (e) {
                label.hide();
            });

        })
    },
    viewPromoBanner: function () {
        if ($(".coupons-bloc-pdp").length > 0) {
            ACC.track.trackPromoBanner();
        }
    },
    _renderMkpCertificate: function (certificatePrice, certificateName, isCertificatedAgency) {
        $('.certificatewrapper').addClass('hidden');
        $('.certificatePriceValue').addClass('hidden');
        $('.js-amds-checkCertif_product_mkp').addClass('hidden');
        if (!jQuery.isEmptyObject(certificatePrice) || certificatePrice > 0) {
            $('.js-amds-checkCertif_product_mkp').removeClass('hidden');

            $("#checkMkpCertif_product").val(isCertificatedAgency);
            $('.certificatePriceValue').find("span").html(certificatePrice);

            if ($('#checkMkpCertif_product').is(':checked')) {
                ACC.product.setCertificateChoiceLogic(true, true);
            }
        }
    }
};

$(document).ready(function () {
    $ajaxCallEvent = true;
    ACC.product.hoverQualityProduct();
});
